import React from 'react';
import styled from 'styled-components';
import { Body, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
 padding: ${Theme.Spacing.xsSpacing} ${Theme.Spacing.mdSpacing};
`;

const Content = () => {
  const { t } = useTranslation('components');

  return (
    <Wrapper>
      <Body type="invalid">
        {t('ordersForm.actionBar.content')}
      </Body>
    </Wrapper>
  );
};

export default Content;
